import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39d70008&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39d70008&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=39d70008&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d70008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d70008')) {
      api.createRecord('39d70008', component.options)
    } else {
      api.reload('39d70008', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39d70008&scoped=true", function () {
      api.rerender('39d70008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/venue/index.vue"
export default component.exports